module.exports = __webpack_public_path__ + "media/images/help/cb-license-review-e31f70d7a3d7e41652d4fe8548cb2876.png";